import { useCallback } from 'react'
import ClickableListItem from 'LuxKit/List/ClickableListItem'

interface Props {
  prompt: string
  disabled: boolean
  onSelect: (prompt: string) => void
}

function ChatLandingTryAskingRow({ prompt, disabled, onSelect }: Props) {
  const handleClick = useCallback(() => {
    onSelect(prompt)
  }, [onSelect, prompt])

  return (
    <ClickableListItem
      size="medium"
      title={prompt}
      disabled={disabled}
      onClick={handleClick}
    />
  )
}

export default ChatLandingTryAskingRow
